export const IMAGE_CDN_URL = "https://image.shopflo.com";
